module.exports = "/_next/static/images/slide5-0b8b3d76be5320425147053c3a883431.webp";